export default {
	title: '设备列表',
	actions: {
		add: '新增',
		edit: '修改',
		delete: '删除',
		batchDelete: '批量删除',
		save: '保存',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		deleteSuccess: '删除成功',
		actionSuccess: '操作成功',
		noDeviceSelected: '请选择要配置的设备',
		noWaveTypeSelected: '请选择波形类型',
		dataCollectSuccess: '数据采集下发成功',
		configSuccess: '配置成功',
		settingSuccess: '设置成功'
	},
	labels: {
		deviceList: '设备列表',
		startStopRecord: '启停记录',
		dilutionStrategy: '稀释策略',
		dataCollectIssuance: '数据采集下发',
		markConfig: '标记配置',
		diagnose: '诊断',
		deviceSensorConfig: '设备测点配置',
		alarmTag: '告警标记',
		runAlarmAlgorithm: '跑告警算法',
		notRunAlarmAlgorithm: '不跑告警算法'
	},
	buttons: {
		dilutionStrategy: '稀释策略',
		dataCollectIssuance: '数据采集下发',
		add: '新增',
		markConfig: '标记配置',
		batchDelete: '批量删除',
		deviceMoveOrg: '设备调动记录',
		diagnose: '诊断',
		deviceSensorConfig: '设备测点配置',
		startStopRecord: '启停记录',
		edit: '修改',
		delete: '删除',
		cancel: '取消',
		confirm: '确定'
	},
	table: {
		deviceName: '设备名称',
		deviceNumber: '设备编号',
		projectNumber: '项目编号',
		org: '所属机构',
		type: '类型',
		status: '状态',
		warnLevel: '告警等级',
		runAlarmAlgorithm: '是否跑告警算法',
		modelImage: '模型图',
		deviceImage: '设备图',
		action: '操作',
		oldOrgName: '原机构',
		newOrgName: '新机构',
		moveDate: '迁移时间',
		operatorName: '操作人'
	},
	form: {
		placeholder: {
			deviceNumber: '设备编号',
			deviceName: '设备名称',
			org: '机构名称',
			projectNumber: '项目编号',
			type: '类型名称',
			status: '状态'
		},
		add: '新增',
		update: '修改',
		cancel: '取消',
		confirm: '确定'
	},
	dialog: {
		dilutionStrategy: '稀释策略',
		dataCollectIssuance: '数据采集下发',
		shortWaveform: '短波形',
		longWaveform: '长波形',
		quarter: '季度',
		halfYear: '半年',
		year: '年度',
		markConfig: '标记配置',
		deviceMoveOrg: '设备调动记录',
		alarmTagRequired: '告警标记不能为空',
		closeLongWaveform: '关闭长波形采集',
		openLongWaveform: '开启长波形采集',
		closeLongWaveformConfirm: '该操作将影响【全部设备】的"长波形"存储配置（关闭后长波形将不再保存），高频/低频波形不受影响。是否继续？',
		openLongWaveformConfirm: '该操作将影响【全部设备】的"长波形"存储配置（开启后长波形将恢复保存），高频/低频波形不受影响。是否继续？',
		setCjpzSuccess: '设置成功'
	},
	config: {
		deviceSensorConfig: '设备测点配置',
		gridLayout: '格栅布局',
		deviceName: '设备名称',
		deviceNumber: '设备编号',
		project: '所属项目',
		status: '状态',
		deviceType: '设备类型',
		diagnosticToolType: '诊断工具类型',
		org: '机构',
		deviceImage: '设备图片',
		deviceModelImage: '设备模型图',
		sort: '排序',
		pointName: '测点名称',
		startStopSpeed: '启停速度值',
		startStopAcc: '启停加速度值',
		abnormalTemp: '异常温度值',
		abnormalSpeed: '异常速度值',
		accThreshold: '加速度门限阈值',
		speedThreshold: '速度门限阈值',
		tempThreshold: '温度门限阈值',
		longWaveformCollect: '长波形是否采集',
		label1: '标签 1',
		nameRequired: '必填项不能为空',
		orgPlaceholder: '机构 (诊断)'
	},
	index: {
		deviceList: '设备列表',
		startStopRecord: '启停记录'
	}
}
